import React, { useContext, useEffect, useState } from 'react'
import AdminContext from '../../admin/StateContext/Application'
import { dashboard_bg_1, active_tenders ,DeactiveTenders} from '../../../public/LoginImages/importimages';
const currentDate = new Date();

// Get the current date in the format YYYY-MM-DD
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
const day = String(currentDate.getDate()).padStart(2, '0');
const formattedCurrentDate = `${year}-${month}-${day}`;

const Dashboard = () => {
  const content = useContext(AdminContext)
  const { GetAuctionsList, EcsRefund, DashboardReports } = content

  const [Data, SetData] = useState({})
  const [form, setForm] = useState({
    formattedCurrentDate: formattedCurrentDate
  })
  useEffect(() => {
    Search()
  }, [form.formattedCurrentDate])
  const Search = async (e) => {
    try {
      let data = await GetAuctionsList("getactiveauctions");
      let deactive = await GetAuctionsList("getdeactiveauctions");
      let Refunddata = await EcsRefund();
      let Dashboardrep = await DashboardReports(form.formattedCurrentDate)
      
      let obj = {
        "Livedata": data,
        "Deactivedata": deactive,
        "Refunddata": Refunddata,
        "Dashboardrep": Dashboardrep[0]
      };
      SetData(obj);
      console.log("Data",obj);
      
    } catch (error) {
      console.error('Error during data fetching:', error);
    }
  }
  useEffect(() => {
  }, [Data]);
  // return (
  //   <div style={{ backgroundColor: "#0000" ,width:'80vw'}}>



  //     <div className='mx-5' style={{ height: "12rem" }}>
  //       <div className='midheader mx-5'>
  //         <img src={dashboard_bg_1}></img>
  //       </div>
  //       <div className='midheadersibling'>
  //         <div className='mb-3 mx-3'>
  //           <h4 style={{ color: "#e73d26" }}><b>Welcome To Dashboard</b></h4>
  //           <h6><b>Today's Data</b></h6>
  //         </div>
  //         <div className=' mb-3 mx-3'>
  //           <div className="card-body">
  //             <input type='date' className='form-control' id='formattedCurrentDate' value={form.formattedCurrentDate} onChange={(e) => { setForm({ ...form, [e.currentTarget.id]: e.currentTarget.value }) }} style={{ width: "10rem", borderRadius: "20px", position: "relative", zIndex: "50" }}></input>
  //           </div>
  //         </div>
  //       </div>
  //     </div>



  //     <div className='my-5'  style={{ display: 'grid', flexWrap: 'wrap', justifyContent: 'center', padding: '1rem' }}>
  //       {/* <div style={{display:'flex' ,width:'100%',justifyContent:'space-around'}}>
  //       <div className="card " style={{ width: "16rem",border:'none',borderRadius:'10px' }}>
  //         <div className="row g-0">
  //           <div className="col-md-2" style={{ backgroundImage: `url('${active_tenders}')`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', marginLeft: '8px' }}>
  //           </div>
  //           <div className="col-md-9" style={{display:'grid',alignItems:'center',alignContent:'center'}}>
  //               <div className='my-2 mx-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //                 <h6 style={{ fontSize: '14px', fontWeight: 'bold' }}>Active Tenders</h6>
  //                 <h6 className="text-right" style={{ fontSize: 'large', color: 'green' }}><b>{Data.Livedata?.length}</b></h6>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="card " style={{ width: "16rem",border:'none',borderRadius:'10px' }}>
  //         <div className="row g-0">
  //           <div className="col-md-2" style={{ backgroundImage: `url('${DeactiveTenders}')`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', marginLeft: '8px' }}>
  //           </div>
  //           <div className="col-md-9" style={{display:'grid',alignItems:'center',alignContent:'center'}}>
  //               <div className='my-2 mx-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //                 <h6 style={{ fontSize: '14px', fontWeight: 'bold' }}>Deactive Tenders</h6>
  //                 <h6 className="text-right" style={{ fontSize: 'large', color: 'red' }}><b>{Data.Refunddata?.length}</b></h6>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="card " style={{ width: "16rem",border:'none',borderRadius:'10px' }}>
  //         <div className="row g-0">
  //           <div className="col-md-2" style={{ backgroundImage: `url('${DeactiveTenders}')`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', marginLeft: '8px' }}>
  //           </div>
  //           <div className="col-md-9" style={{display:'grid',alignItems:'center',alignContent:'center'}}>
  //               <div className='my-2 mx-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //                 <h6 style={{ fontSize: '14px', fontWeight: 'bold' }}>Deactive Tenders</h6>
  //                 <h6 className="text-right" style={{ fontSize: 'large', color: 'red' }}><b>{Data.Refunddata?.length}</b></h6>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       </div> */}
        
        

  //       <div className='' style={{ display: "flex" }}>
  //         <div className="card mx-3 my-3" style={{ borderRadius: "20px", width: "20rem", background: 'linear-gradient(to bottom, rgb(26 124 235 / 59%) 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)', backdropFilter: 'blur(52px)' }}>
  //           <div className="card-body" style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
  //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //               <i className='fa-solid fa-gavel fa-5x'></i>
  //               <h5 className="card-title">Active Scheme</h5>
  //             </div>
  //             <h1 className="card-subtitle mb-2 text-body-secondary text-center  ">{Data.Livedata?.length}</h1>
  //           </div>
  //         </div>

  //         <div className="card mx-3 my-3" style={{ borderRadius: "20px", width: "20rem", background: 'linear-gradient(to bottom, #34d5bd 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)', backdropFilter: 'blur(52px)' }}>
  //           <div className="card-body" style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
  //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //               <i className='fa-solid fa-ban fa-5x'></i>
  //               <h5 className="card-title">Deactive Scheme</h5>
  //             </div>
  //             <h1 className="card-subtitle mb-2 text-body-secondary text-center  ">{Data.Deactivedata?.length}</h1>
  //           </div>
  //         </div>

  //         <div className="card mx-3 my-3" style={{ borderRadius: "20px", width: "20rem", background: 'linear-gradient(to bottom, hotpink 10%, #ffffff 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)', backdropFilter: 'blur(52px)' }}>
  //           <div className="card-body" style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
  //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //               <i className='fa-solid fa-users fa-5x'></i>
  //               <h5 className="card-title">Registrations</h5>
  //             </div>
  //             <h1 className="card-subtitle mb-2 text-body-secondary text-center">{Data.Dashboardrep?.TotalRegistrations}</h1>
  //           </div>
  //         </div>
  //       </div>

  //       <div style={{ display: "flex" }}>
  //         <div className="card mx-3 my-3" style={{ borderRadius: "20px", width: "30rem", background: 'linear-gradient(to bottom, pink 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)', backdropFilter: 'blur(52px)' }}>
  //           <div className="card-body" style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
  //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //               <i className='fa-solid fa-hand-holding-dollar fa-5x'></i>
  //               <h5 className="card-title">Ernest Money Deposit</h5>
  //             </div>
  //             <h1 className="card-subtitle mb-2 text-body-secondary text-center  ">{Data.Dashboardrep?.ErnestMoneyDeposit}</h1>
  //           </div>
  //         </div>

  //         <div className="card mx-3 my-3" style={{ borderRadius: "20px", width: "30rem", height: "8rem", background: 'linear-gradient(to bottom, #fc6767 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)', backdropFilter: 'blur(52px)' }}>
  //           <div className="card-body" style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
  //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //               <i className='fa-solid fa-chart-line fa-5x'></i>
  //               <h5 className="card-title "> GST Collection</h5>
  //             </div>
  //             <h1 className="card-subtitle mb-2 text-body-secondary text-center">{Data.Dashboardrep?.TotalGSTCollected}</h1>
  //           </div>
  //         </div>
          
  //       </div>
  //       <div className="card mx-3 my-3" style={{ borderRadius: "20px", width: "30rem", height: "8rem", background: 'linear-gradient(to bottom, lightgreen 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)', backdropFilter: 'blur(52px)' }}>
  //           <div className="card-body" style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
  //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //               <i className='fa-solid fa-chart-line fa-5x'></i>
  //               <h5 className="card-title ">Total Scheme Fee</h5>
  //             </div>
  //             <h1 className="card-subtitle mb-2 text-body-secondary text-center">{Data.Dashboardrep?.TotalTenderFee}</h1>
  //           </div>
  //         </div>
  //     </div>





  //   </div>
  // )
    return (
      <div style={{ backgroundColor: "#0000", width: '80vw' }}>
  
  
  
        <div className='mx-5' style={{ height: "12rem" }}>
          {/* <div className='midheader mx-5'>
            <img src={dashboard_bg_1}></img>
          </div> */}
          <div className='midheader mx-5 text-center'>
            <img
              src={dashboard_bg_1}
              style={{
                maxWidth: "180px",     
                width: "100%",      
                height: "auto",
              }}
              alt=""
            />
          </div>
  
          <div className='midheadersibling'>
            <div className='mb-3 mx-3'>
              <h4 style={{ color: "#e73d26" }}><b>Welcome To Dashboard</b></h4>
              <h6><b>Today's Data</b></h6>
            </div>
            <div className=' mb-3 mx-3'>
              <div className="card-body">
                <input type='date' className='form-control' id='formattedCurrentDate' value={form.formattedCurrentDate} onChange={(e) => { setForm({ ...form, [e.currentTarget.id]: e.currentTarget.value }) }} style={{ width: "10rem", borderRadius: "20px", position: "relative", zIndex: "50" }}></input>
              </div>
            </div>
          </div>
        </div>
  
  
        <div className="container my-5">
          <div className="row g-4 justify-content-center">
  
            {/* Active Scheme */}
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
              <div className="card flex-fill" style={{ borderRadius: "20px", background: 'linear-gradient(to bottom, rgb(26 124 235 / 59%) 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)' }}>
                <div className="card-body text-center">
                  <i className='fa-solid fa-gavel fa-3x mb-2'></i>
                  <h5>Active Scheme</h5>
                  <h1>{Data.Livedata?.length}</h1>
                </div>
              </div>
            </div>
  
            {/* Deactive Scheme */}
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
              <div className="card flex-fill" style={{ borderRadius: "20px", background: 'linear-gradient(to bottom, #34d5bd 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)' }}>
                <div className="card-body text-center">
                  <i className='fa-solid fa-ban fa-3x mb-2'></i>
                  <h5>Deactive Scheme</h5>
                  <h1>{Data.Deactivedata?.length}</h1>
                </div>
              </div>
            </div>
  
            {/* Registration */}
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex">
              <div className="card flex-fill" style={{ borderRadius: "20px", background: 'linear-gradient(to bottom, hotpink 10%, #ffffff 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)' }}>
                <div className="card-body text-center">
                  <i className='fa-solid fa-users fa-3x mb-2'></i>
                  <h5>Registrations</h5>
                  <h1>{Data.Dashboardrep?.TotalRegistrations}</h1>
                </div>
              </div>
            </div>
  
            {/* EMD */}
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 d-flex">
              <div className="card flex-fill" style={{ borderRadius: "20px", background: 'linear-gradient(to bottom, pink 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)' }}>
                <div className="card-body text-center">
                  <i className='fa-solid fa-hand-holding-dollar fa-3x mb-2'></i>
                  <h5>Ernest Money Deposit</h5>
                  <h1>{Data.Dashboardrep?.ErnestMoneyDeposit}</h1>
                </div>
              </div>
            </div>
  
            {/* GST Collection */}
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 d-flex">
              <div className="card flex-fill" style={{ borderRadius: "20px", background: 'linear-gradient(to bottom, #fc6767 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)' }}>
                <div className="card-body text-center">
                  <i className='fa-solid fa-chart-line fa-3x mb-2'></i>
                  <h5>GST Collection</h5>
                  <h1>{Data.Dashboardrep?.TotalGSTCollected}</h1>
                </div>
              </div>
            </div>
  
            {/* Total Fees */}
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 d-flex">
              <div className="card flex-fill" style={{ borderRadius: "20px", background: 'linear-gradient(to bottom, lightgreen 10%,#FFFFFF 100%)', boxShadow: '0 4px 8px rgba(0, 0, 0, 1.1)' }}>
                <div className="card-body text-center">
                  <i className='fa-solid fa-chart-line fa-3x mb-2'></i>
                  <h5>Total Scheme Fee</h5>
                  <h1>{Data.Dashboardrep?.TotalTenderFee}</h1>
                </div>
              </div>
            </div>
  
          </div>
        </div>
  
  
  
  
      </div>
    )
}

export default Dashboard